import React from 'react';

const baseClasses = [
  'w-full px-4 py-2.5 rounded-md bg-white',
  'border border-sand-200 text-ink-900 placeholder:text-ink-400',
  'focus:outline-none focus:ring-2 focus:ring-terra-400 focus:border-terra-400',
  'transition-all duration-200 text-sm',
].join(' ');

const errorClasses = 'border-uae-red focus:ring-uae-red focus:border-uae-red';

export default function Input({
  label,
  error,
  id,
  as: Tag = 'input',
  className = '',
  ...props
}) {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={id} className="text-sm font-medium text-ink-700">
          {label}
        </label>
      )}
      <Tag
        id={id}
        className={[baseClasses, error ? errorClasses : '', className].join(' ')}
        {...props}
      />
      {error && <p className="text-xs text-uae-red">{error}</p>}
    </div>
  );
}
